export default "__VITE_ASSET__BPhm2YOe__"